export const PLAY_BINGO_NOW_BUTTON = 'play-bingo-now-button';

export enum BUTTON_IDS {
    PLAY_BINGO_NOW_BUTTON_ID = 'PLAY_BINGO_NOW_BUTTON_ID',
    PLAY_BINGO_NOW_BUTTON_ID_MOBILE = 'PLAY_BINGO_NOW_BUTTON_ID_MOBILE'
}
